import { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

/** Where Shield's hosted verification form sends the business back to. */
export default function BankingOnboardingReturn() {
  const [params] = useSearchParams();
  const { user } = useAuth() || {};
  const status = params.get("onboarding_status");

  useEffect(() => {
    if (status === "approved") {
      toast.success("Business verified. Your account number is ready.");
    } else if (status === "pending") {
      toast.info("Shield is reviewing your business. We will update this automatically.");
    } else if (status === "rejected") {
      toast.error("Shield could not verify this business. Contact support to re-submit.");
    }
  }, [status]);

  if (!user) return <Navigate to="/login" replace />;
  return (
    <Navigate
      to={user.role === "buyer" ? "/buyer/banking" : "/seller/banking"}
      replace
      data-testid="banking-onboarding-return"
    />
  );
}
